import { UtilService } from '@app/shared/services/util.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { LocalidadeService } from '@app/shared/services';
import { EscolaridadeService } from '@app/shared/services/escolaridade.service';

import { environment } from '@environments/environment';

import { Censo, ChaveValor, ConfigCamposFormulario, Loading, Municipio } from '@app/shared/models';

@Component({
  selector: 'app-form-dados-pessoais',
  templateUrl: './form-dados-pessoais.component.html',
  styleUrls: ['./form-dados-pessoais.component.scss']
})
export class FormDadosPessoaisComponent implements OnInit {

  @Input() formEtapa1: FormGroup = null;
  @Input() ufNaturalidadeId: number;
  @Input() configCamposFormulario: ConfigCamposFormulario[];
  @Input() censo: Censo;

  cliente = environment.cliente;

  temDeficiencia: boolean;
  escolaridades: ChaveValor[] = [];
  estados: ChaveValor[] = [];
  paises: ChaveValor[] = [];
  todosMunicipios: Municipio[] = [];
  municipios: Municipio[] = [];
  carregar = new Loading();
  carregarMunicipios = new Loading();

  constructor(
    private localidadeService: LocalidadeService,
    private escolaridadeService: EscolaridadeService,
    private utilService: UtilService
  ) {
    this.obterUfs();
    this.obterNacionalidades();
    this.escolaridadeService.getEscolaridade().subscribe((data) => this.escolaridades = data);
  }

  ngOnInit(): void {
    this.validarDescricaoDeficiente();

    if (this.formEtapa1.get('ufNaturalidadeId').value) {
      this.lidarComUf(this.formEtapa1.get('ufNaturalidadeId').value);
    }
  }

  lidarComUf(uf: any) {
    if (uf == 'null' || uf == null) {
      this.municipios = [];
      this.formEtapa1.get('ufNaturalidadeId').reset();
      this.formEtapa1.get('municipioId').reset();
      return;
    }

    this.localidadeService.getMunicipios(uf, this.carregarMunicipios).subscribe(municipios => {
      this.municipios = municipios
      if (municipios.find(mun => mun.id == this.formEtapa1.get('municipioId').value)) return;
      else this.formEtapa1.get('municipioId').reset();
    });
  }

  obterUfs(): void {
    this.localidadeService.getEstados(this.carregar).subscribe(estados => this.estados = estados);
  }

  obterNacionalidades(): void {
    this.localidadeService.getPaises(this.carregar).subscribe(paises => this.paises = paises);
  }

  validarDescricaoDeficiente(): void {
    this.formEtapa1.get('deficiente').valueChanges.subscribe(value => {
      this.temDeficiencia = value == 'true';
      this.utilService.alternarValidatorRequiredComDesativacao(this.formEtapa1.get('deficienteDescricao'), this.temDeficiencia);
    })
  }

  get deficienteValue(): any {
    return this.formEtapa1.get('deficiente').value
  }

  get verificarForm(): any {
    return this.utilService.verificarForm(this.formEtapa1);
  }

  isRequired(campo: string): any {
    return this.utilService.isRequiredField(campo, this.formEtapa1)
  }

  isVisible(campo: string): boolean {
    if (!this.configCamposFormulario) return null;

    const isVisible = this.configCamposFormulario.find((_: any) => _.nomeCampo == campo).visivel
    return isVisible;
  }
}
